<template>
  <svg
    aria-hidden="true"
    fill="none"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="7.488" cy="8.371" r="5.941" stroke="currentColor" />
    <path d="m12.7 12.836 4.464 4.465" stroke="currentColor" />
  </svg>
</template>
